import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledCddAccessContainer = styled(Container)`
  padding-top: 3rem;
  padding-bottom: 8rem;
  margin-top: 2rem;
`;

export const StyledErrorMessage = styled.p`
  color: ${({ theme }) => theme.colors.error.main};
  margin: 1rem 0;
`;

export const StyledActionContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const StyledFormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const StyledRadioGroup = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
`;

export const StyledErrorIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.error.main};
  height: 2.6rem;
`;

export const StyledModalWrapper = styled.div`
  padding: 2.4rem;
`;

export const StyledModalContent = styled.div`
  margin: 2.4rem 0;

  button {
    margin-top: 1.6rem;
  }
`;

export const StyledModalTitle = styled.h2`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  margin: 0;
  font-size: ${({ theme }) => theme.fonts.sizes.medium};

  svg {
    margin-right: 0.8rem;
  }
`;

export const StyledModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledModalIcon = styled.span`
  margin-right: 0.8rem;
  display: inline-flex;
`;
